import { CloudSync, Folder, DriveFolderUpload, SettingsSuggest } from "mosaic-react-icons";
const navigation = {
    repository: [
        {
            level: 0,
            priority: 1,
            name: "label(Data Upload)",
            to: "/:projectId/:fiscalYear/:importId/repository/activity",
            exact: true,
            icon: DriveFolderUpload,
        },
        {
            level: 0,
            priority: 2,
            name: "label(Folders)",
            to: "/:projectId/:fiscalYear/:importId/repository/folders",
            icon: Folder,
        },
        {
            level: 0,
            priority: 3,
            name: "label(Invalid Files)",
            to: "/:projectId/:fiscalYear/:importId/repository/invalid_files",
            icon: Folder,
            exact: true,
        },
        {
            level: 0,
            priority: 4,
            name: "label(Deleted Files)",
            to: "/:projectId/:fiscalYear/:importId/repository/deleted_file_logs",
            icon: Folder,
            exact: true,
        },
    ],
    submission_saft: [
        {
            level: 0,
            priority: 5,
            name: "label(Files Submission)",
            to: "/:projectId/:fiscalYear/:importId/repository/submission_saft",
            exact: true,
            icon: CloudSync,
        },
    ],
    merge_collisions: [
        {
            level: 0,
            priority: 6,
            name: "label(Merge Collisions)",
            to: "/:projectId/:fiscalYear/:importId/repository/merge_collisions",
            exact: true,
            icon: Folder,
        },
    ],
    generic_generator: [
        {
            level: 0,
            priority: 7,
            name: "label(SAF-T Generation)",
            to: "/:projectId/:fiscalYear/:importId/repository/generation",
            exact: true,
            icon: SettingsSuggest,
        },
    ],
    custom_report: [
        {
            level: 0,
            priority: 8,
            name: "label(Custom Reports)",
            to: "/:projectId/:fiscalYear/:importId/repository/custom_reports_by_project",
            exact: true,
            icon: SettingsSuggest,
        },
    ],
};

const filteredQueriesByModules = (modules) => {
    if (modules && modules.length > 0) {
        const filteredRoutes = (modules || []).reduce((acc, elem) => {
            const menuArray = navigation[`${elem}`];
            const queries = (menuArray || [])
                .filter((elem) => elem.queries !== undefined)
                .map(({ queries }) => {
                    return queries;
                });
            acc.push(...queries);
            return acc;
        }, []);
        return filteredRoutes.flat();
    }
    return [];
};

const filteredNavigationByModules = (modules) => {
    let resNavigation = [];
    if (modules && modules.length > 0) {
        const filteredNavigation = (modules || []).reduce((acc, elem) => {
            const menuArray = navigation[`${elem}`];
            if (menuArray) {
                acc.push(...menuArray);
            }
            return acc;
        }, []);
        const orderedNavigation = filteredNavigation.sort(function (a, b) {
            return a.priority - b.priority;
        });

        resNavigation.push(...orderedNavigation);
    }
    return resNavigation;
};

const filteredNavigationByModulesForNestedLinks = (modules) => {
    return (filteredNavigationByModules(modules) || []).map(({ name, to }) => {
        return { name, to }
    });
};

export { filteredNavigationByModules, filteredQueriesByModules, filteredNavigationByModulesForNestedLinks };
